export enum BranchesRoutes {
  manageBranches = 'manage-branches',
  branchUsers = 'branch-users',
}
